var render = function render(){var _vm=this,_c=_vm._self._c;return _c('D3BarChart',{attrs:{"config":_vm.chart_config,"datum":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }